<template>
  <div>
    <div>
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="card-title">{{$t('Contract Payments')}}</h4>
          <span class="badge badge-success" style="float: right"
            >Total: {{ contractPayments.total }}</span
          >
        </div>
        <div class="card-content">
          <div class="card-body pb-1">
            <div class="row align-items-center justify-content-center mt-2">
              <div class="col-12">
                <div
                  id="contract-payments-stats-chart"
                  class="d-flex justify-content-center"
                ></div>
              </div>
            </div>

            <div class="row mt-2 mb-1">
              <div class="col-md-6 col-sm-12">
                <strong>{{$t('Confirmed Payments Per Contract')}}: </strong>
              </div>
              <div class="col-md-6 col-sm-12 justify-content-end d-flex">
                <span
                  class="badge badge-primary"
                  v-if="contractPayments.averageConfirmedPaymentsPerContract"
                >
                  {{
                    contractPayments.averageConfirmedPaymentsPerContract.toFixed(
                      2
                    )
                  }}
                  {{$t('(Average)')}}
                </span>
              </div>
            </div>

            <div class="row mt-2 mb-1">
              <div class="col-md-6 col-sm-12">
                <strong>{{$t('(Payments Per Contract)')}}: </strong>
              </div>
              <div class="col-md-6 col-sm-12 justify-content-end d-flex">
                <span
                  class="badge badge-primary"
                  v-if="contractPayments.averagePaymentsPerContract"
                >
                  {{ contractPayments.averagePaymentsPerContract.toFixed(2) }}
                  {{$t('(Average)')}}
                </span>
              </div>
            </div>

            <hr />
            <h4 class="card-title">{{$t('Average Confirmed Values')}}</h4>
            <ul class="list-group list-group-flush">
              <li
                class="list-group-item border-0 d-flex align-items-center justify-content-between px-0"
                v-for="(
                  count, value
                ) in contractPayments.averageConfirmedValues"
                :key="value"
              >
                <div class="list-left d-flex">
                  <div class="list-content">
                    <span class="list-title capitalize">{{
                      value.replaceAll("_", " ")
                    }}</span>
                  </div>
                </div>
                <span class="badge badge-secondary">{{ count }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts'
export default {
  props: ["contractPayments"],
  methods: {
    initPaymentsChart() {
      const donutChartOption = {
        chart: {
          width: 200,
          type: "donut",
        },
        dataLabels: {
          enabled: false,
        },
        series: [],
        labels: [],
        stroke: {
          width: 0,
          lineCap: "round",
        },
        colors: ["#00CFDD", "#FDAC41", "#5A8DEE", "#39DA8A"],
        plotOptions: {
          pie: {
            donut: {
              size: "90%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "15px",
                  colors: "#596778",
                  offsetY: 20,
                  fontFamily: "IBM Plex Sans",
                },
                value: {
                  show: true,
                  fontSize: "26px",
                  fontFamily: "Rubik",
                  color: "#475f7b",
                  offsetY: -20,
                  formatter: function (val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#828D99",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce(function (a, b) {
                      return a + b;
                    }, 0);
                  },
                },
              },
            },
          },
        },
        legend: {
          show: false,
        },
      };

      const donutChart = new ApexCharts(
        document.querySelector("#contract-payments-stats-chart"),
        donutChartOption
      );

      this.contractPayments.statuses.counts.forEach((type) => {
        for (const [key, value] of Object.entries(type)) {
          donutChartOption.labels.push(key.replaceAll("_", " "));
          donutChartOption.series.push(value);
        }
      });

      donutChart.render();
    },
  },

  mounted() {
    this.initPaymentsChart();
  },
};
</script>